import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import OffcanvasComponent from '@/components/Offcanvas/OffcanvasComponent.vue';
import { onMounted, onUnmounted, ref } from 'vue';
import SplashScreenComponent from './components/SplashScreenComponent.vue';
import useUser from './composables/useUser';
import useWebSocket from './composables/useWebSocket';
import useGeolocation from './composables/useGeolocation';
import webSocketService from './services/WebSocketService';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { syncUser} = useUser()
const showSplash = ref(false)
const {connectWebSocket, disconnectWebSocket} = useWebSocket(webSocketService)
const { getUserLocation } = useGeolocation()
if(localStorage.getItem('SPLASH_SHOWN') != 'true') {
  showSplash.value = true
}
localStorage.setItem('SPLASH_SHOWN', 'true')
syncUser()


onMounted(() => {
  connectWebSocket()
  // Request geolocation permission on app startup
  getUserLocation()
})

onUnmounted(() => {
  disconnectWebSocket()
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(OffcanvasComponent),
    (showSplash.value)
      ? (_openBlock(), _createBlock(SplashScreenComponent, {
          key: 0,
          onOnAnimationFinished: _cache[0] || (_cache[0] = ($event: any) => (showSplash.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})